import React, {useMemo} from "react";
import {inject, observer} from "mobx-react";
import {useNavigate} from "react-router-dom";
//local
import {hashes} from "constants/tabs.const";
import cn from "classnames";

export const SubscriptionUpgradeCustomLocalModal = inject("store")(
  observer(
    ({
      store: {auth},
      canPermissions,
      prefixLinkCustomContent,
      suffixLinkCustomContent,
      needDirectPurchase,
      directSubscriptionLink,
      addClass,
      addStyle,
      children,
    }) => {
      const navigate = useNavigate();
      const {subscribedPermissions} = auth;

      const permittedSubscription = useMemo(
        () =>
          !!canPermissions && subscribedPermissions?.[canPermissions[0]]
            ? subscribedPermissions[canPermissions[0]][0]
            : null,
        [canPermissions, subscribedPermissions]
      );

      return (
        <div
          className={cn("subscription-upgrade-custom-modal-local df-column", {
            [addClass]: !!addClass,
          })}
          style={addStyle}
        >
          {prefixLinkCustomContent}
          <div
            onClick={() =>
              directSubscriptionLink
                ? navigate({hash: directSubscriptionLink})
                : needDirectPurchase
                ? navigate(
                    {hash: hashes.SUBSCRIPTION},
                    {state: {purchasedSubscription: permittedSubscription}}
                  )
                : navigate({hash: hashes.SUBSCRIPTION})
            }
            className="subscription-upgrade-custom-modal-local__content"
          >
            {children}
          </div>

          {suffixLinkCustomContent}
        </div>
      );
    }
  )
);
